import React, {Fragment} from 'react';
const SummaryItemGroupContainer = props => {
    return (
        <Fragment>
        <div className="summary-items-group">{props.children}</div>
        </Fragment>
    );
};

export default SummaryItemGroupContainer;